module.exports = __webpack_public_path__ + "static/media/events.c8d12872.svg";